import React from "react";
import { Tabs } from 'antd';
import DispenseChemicalTruckList from '../components/chemical/DispenseChemicalTruckList'
import DispenseChemicalAllList from "../components/chemical/DispenseChemicalAllList";

export default function QualityChemicalView() {

  const items = [
    {
      key: 'truck',
      label: 'รถน้ำยางสด',
      children: <DispenseChemicalTruckList/>,
    },
    {
      key: 'all',
      label: 'รายการจ่ายสารเคมีทั้งหมด',
      children: <DispenseChemicalAllList/>,
    }
  ];

  return (
    <div>
      <Tabs 
        destroyInactiveTabPane
        defaultActiveKey="quality" 
        items={items}
        style={{ marginTop : 15}}
      />

    </div>
  )
}